const isYYYYMMFF = (date) => {
  const YYYYMMDDFormat = /\d{4}-\d{2}-\d{2}/; // nnnn-nn-nn
  return typeof date === 'string' && YYYYMMDDFormat.test(date);
}

export const areSameDay = date => otherDate => {
  if (typeof date === 'undefined' || date === null) return;
  if (typeof otherDate === 'undefined' || otherDate === null) return;

  if (typeof date === 'string') date = new Date(date);
  if (typeof otherDate === 'string') otherDate = new Date(otherDate);

  return yyyymmdd(date) === yyyymmdd(otherDate);
};

export const currentMonthAndYearString = () => (
  new Date().toLocaleString('default', { month: 'long', year: 'numeric' })
);

export const startAndEndTimestampsForDate = date => {
  const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours, in milliseconds
  date = new Date(yyyymmdd(date)); // assign new Date object with midnight timestamp to `date`
  const startOfDate = date.valueOf(); // timestamp
  const endOfDate = startOfDate + twentyFourHours;
  return [startOfDate, endOfDate];
};

export const truncate = (text, maxLength = 100) => (
  text.length > maxLength ? text.substring(0, maxLength - 1) + '…' : text
);

export const yyyymmdd = date => {
  if (isYYYYMMFF(date)) return date; // already in correct format

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return [
    String(year).padStart(4, '0'),
    String(month).padStart(2, '0'),
    String(day).padStart(2, '0')
  ].join('-');
}
